import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "container app-shell" }
const _hoisted_2 = { class: "header-section" }
const _hoisted_3 = { class: "app-shell__body" }
const _hoisted_4 = { class: "sidebar-item" }
const _hoisted_5 = { class: "icon" }
const _hoisted_6 = {
  key: 0,
  class: "title"
}
const _hoisted_7 = { class: "sidebar-item" }
const _hoisted_8 = { class: "icon" }
const _hoisted_9 = {
  key: 0,
  class: "title"
}
const _hoisted_10 = { class: "sidebar-item" }
const _hoisted_11 = { class: "icon" }
const _hoisted_12 = {
  key: 0,
  class: "title"
}
const _hoisted_13 = { class: "sidebar-item" }
const _hoisted_14 = { class: "icon" }
const _hoisted_15 = {
  key: 0,
  class: "title"
}
const _hoisted_16 = { class: "sidebar-item" }
const _hoisted_17 = { class: "icon" }
const _hoisted_18 = {
  key: 0,
  class: "title"
}
const _hoisted_19 = { class: "sidebar-item" }
const _hoisted_20 = { class: "icon" }
const _hoisted_21 = {
  key: 0,
  class: "title"
}
const _hoisted_22 = { class: "sidebar-item" }
const _hoisted_23 = { class: "icon" }
const _hoisted_24 = {
  key: 0,
  class: "title"
}
const _hoisted_25 = { class: "sidebar-item" }
const _hoisted_26 = { class: "icon" }
const _hoisted_27 = {
  key: 0,
  class: "title"
}
const _hoisted_28 = { class: "sidebar-item" }
const _hoisted_29 = { class: "icon" }
const _hoisted_30 = {
  key: 0,
  class: "title"
}
const _hoisted_31 = ["href"]
const _hoisted_32 = { class: "sidebar-item" }
const _hoisted_33 = { class: "icon" }
const _hoisted_34 = {
  key: 0,
  class: "title"
}
const _hoisted_35 = ["href"]
const _hoisted_36 = { class: "sidebar-item" }
const _hoisted_37 = { class: "icon" }
const _hoisted_38 = {
  key: 0,
  class: "title"
}
const _hoisted_39 = { class: "icon" }
const _hoisted_40 = {
  key: 0,
  class: "title"
}
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "main app-shell__main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_brand_logo = _resolveComponent("app-brand-logo")!
  const _component_app_toggle = _resolveComponent("app-toggle")!
  const _component_app_option = _resolveComponent("app-option")!
  const _component_app_dropdown = _resolveComponent("app-dropdown")!
  const _component_app_burger_menu = _resolveComponent("app-burger-menu")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_sidebar = _resolveComponent("app-sidebar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_header, null, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_2, [
          _createVNode(_component_app_brand_logo),
          _createElementVNode("section", null, [
            _createVNode(_component_app_toggle, {
              modelValue: _ctx.isDark,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isDark) = $event)),
              variant: "theme",
              onToggled: _ctx.toggled
            }, null, 8, ["modelValue", "onToggled"]),
            _createVNode(_component_app_dropdown, {
              modelValue: _ctx.language,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.language) = $event)),
              label: "name"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (item) => {
                  return (_openBlock(), _createBlock(_component_app_option, {
                    key: item,
                    value: item
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (_ctx.isMobile)
              ? (_openBlock(), _createBlock(_component_app_burger_menu, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("section", _hoisted_3, [
      _createVNode(_component_app_sidebar, null, {
        main: _withCtx(({ isShort }) => [
          _createVNode(_component_router_link, {
            to: "/main/characteristic-colors",
            "active-class": "active-link"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_font_awesome_icon, {
                    size: "xl",
                    icon: ['fas', 'rainbow']
                  })
                ]),
                (!isShort)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.t('characteristicColors')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_router_link, {
            to: "/main/palette-determinant",
            "active-class": "active-link"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_font_awesome_icon, {
                    size: "xl",
                    icon: ['fas', 'brush']
                  })
                ]),
                (!isShort)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.t('paletteDeterminant')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_router_link, {
            to: "/main/cut-palette-color",
            "active-class": "active-link"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_font_awesome_icon, {
                    size: "xl",
                    icon: ['fas', 'scissors']
                  })
                ]),
                (!isShort)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.t('cutPalette')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_router_link, {
            to: "/main/my-palette",
            "active-class": "active-link"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_font_awesome_icon, {
                    size: "xl",
                    icon: ['fas', 'fill-drip']
                  })
                ]),
                (!isShort)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.t('myPalette')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_router_link, {
            to: "/main/palette",
            "active-class": "active-link"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_font_awesome_icon, {
                    size: "xl",
                    icon: ['fas', 'camera']
                  })
                ]),
                (!isShort)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.t('analysisByPhoto')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_router_link, {
            to: "/main/chroma",
            "active-class": "active-link"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_font_awesome_icon, {
                    size: "xl",
                    icon: ['fas', 'eye-dropper']
                  })
                ]),
                (!isShort)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.t('pickColor')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_router_link, {
            to: "/main/ai-agent",
            "active-class": "active-link"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_font_awesome_icon, {
                    size: "xl",
                    icon: ['fas', 'microchip']
                  })
                ]),
                (!isShort)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.t('aiAgent')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_router_link, {
            to: "/main/gallery",
            "active-class": "active-link"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_font_awesome_icon, {
                    size: "xl",
                    icon: ['fas', 'images']
                  })
                ]),
                (!isShort)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.t('gallery')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_router_link, {
            to: "/main/consultation",
            "active-class": "active-link"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_font_awesome_icon, {
                    size: "xl",
                    icon: ['fas', 'user-tie']
                  })
                ]),
                (!isShort)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.t('consultation')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("a", {
            href: _ctx.privacyUrl,
            target: "_blank",
            rel: "noopener"
          }, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'shield-halved']
                })
              ]),
              (!isShort)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.t('privacyPolicy')), 1))
                : _createCommentVNode("", true)
            ])
          ], 8, _hoisted_31),
          _createElementVNode("a", {
            href: _ctx.termsUrl,
            target: "_blank",
            rel: "noopener"
          }, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'file-lines']
                })
              ]),
              (!isShort)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.t('termsOfService')), 1))
                : _createCommentVNode("", true)
            ])
          ], 8, _hoisted_35)
        ]),
        additional: _withCtx(({ isShort, toggle }) => [
          _createElementVNode("div", {
            class: "sidebar-item logout",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
          }, [
            _createElementVNode("div", _hoisted_39, [
              _createVNode(_component_font_awesome_icon, {
                size: "xl",
                icon: ['fas', 'right-from-bracket']
              })
            ]),
            (!isShort)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.t('logout')), 1))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "sidebar-item",
                onClick: toggle
              }, [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: isShort ? ['fas', 'arrow-left'] : ['fas', 'arrow-right']
                }, null, 8, ["icon"])
              ], 8, _hoisted_41))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("main", _hoisted_42, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}